import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getAllLiveBoxes, setAvailableBox, setBusyBox} from 'services/live'
import { Icon, Button, Label, List, Grid, Header, Item } from 'semantic-ui-react';

const styles = {
	blocWhite: {
		boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
		backgroundColor: '#fff',
		padding: 20,
		borderRadius: '0 0 4px 4px',
		overflowY: 'auto',
		height: '100%'

	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
		color: 'white'
	},
};
class Live extends Component {
	constructor(props) {
		super(props);

		this.state = {
			centers: [],
		};
	}
	componentDidMount() {
		this.props.getAllLiveBoxes()
	}
	render() {

		const {live} = this.props
		return (
			<Grid
			textAlign='left'
			style={{ height: '100vh' }}
			verticalAlign='top'
		>
			<Grid.Column style={{ maxWidth: 950, padding: '50 20', margin:'auto', height: '93vh' }}>
				<Header
					as='h2'
					color='teal'
					textAlign='center'
					style={{ backgroundColor: 'rgb(0, 147, 128)' }}
				></Header>
				<div style={styles.blocHeader}>

				<h3>Disponibilités en direct par centre</h3> 
				</div>
			

				<div style={styles.blocWhite}>
					<div style={{ margin: '10px' }}>
					<List divided>
				{live && live.map(c => 
				<List.Item key={c.id}>
				  <Header sub>{c.name}</Header>
				  <List divided selection>
				  <Item.Group divided>
							{c.boxes.map(box => 
							 <Label style={{margin:'3px 10px'}} key={box.id} as='a' onClick={(e) => box.live === 'red' ? this.props.setAvailableBox(box, box.id, c.id) : this.props.setBusyBox(box, box.id, c.id)}  color={box.live === '#6ac906' ? 'green' : box.live}>
							 Boxe {box.liveCallNumber} ({box.name}) {box.occupied_by && box.occupied_by.user  ? <Label.Detail>{`${box.occupied_by.user.first_name} ${box.occupied_by.user.last_name}`}</Label.Detail> : ''}
						   </Label>
								
        
								)}
						</Item.Group>
				  </List>
				</List.Item>)}
				
			  </List>
				<Button onClick={() => this.props.getAllLiveBoxes()}  icon labelPosition='left'> <Icon name='refresh' />Rafraichir</Button></div>
		
					

				</div>
			</Grid.Column>
		</Grid>

			

		)
	}
}

const mapStateToProps = (state) => {
	return {
		live: state.live.list
	};
};

const mapDispatchToProps = {
	getAllLiveBoxes,
	setAvailableBox,
	setBusyBox

};

export default connect(mapStateToProps, mapDispatchToProps)(Live);